import React from 'react';

interface BadgeNewProductProps {
    outline?: boolean;
    className?: string;
}

const BadgeNewProduct = ({
    outline = false,
    className
}: BadgeNewProductProps) => {

    return (
        <div className={`
            ${outline ? 'ring-1 ring-shopfood-notify text-shopfood-notify' : 'bg-shopfood-notify text-white'}
            font-black px-1.5 py-0.5 text-xs ${className}`
            }>
            Novo
        </div>
    );
};

export default BadgeNewProduct;
